<template>
  <v-list>
		<template  v-for="item in model">
			<v-list-group v-if="item.Items"
				:prepend-icon="item.Icon"
				color="white"
				:key="item.$ID"
				@click="onMenuItemClick(item)"
			>
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title v-text="item.Caption"></v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="subItem in item.Items"
          :key="subItem.Caption"
          color="white"
          @click="onMenuItemClick(subItem)"
        >
          <v-list-item-icon>
            <v-icon v-text="subItem.Icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="subItem.Caption"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
			</v-list-group>

			<!-- Отрисовка элементов списка у которых нет дочерних компонентов -->
			<v-list-item 
				v-else
				color="white"
				@click="onMenuItemClick(item)"
				:key="item.$ID"
      >
				<v-list-item-icon>
					<v-icon v-text="item.Icon"></v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title v-text="item.Caption"></v-list-item-title>
				</v-list-item-content>
      </v-list-item>
		</template>
	</v-list>
</template>

<script>
export default {
  props: ['model'],
  methods: {
    onMenuItemClick(item) {
      this.$emit('onMenuItemClick', item)
    }
  }
}
</script>
